var _path, _path2, _path3, _path4, _path5, _rect, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailSent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M4 70.3321C4 69.7302 4.27104 69.1603 4.73794 68.7805L69.4276 16.1596C73.8384 12.5718 80.1616 12.5718 84.5724 16.1596L148.524 68.1803C149.458 68.9399 150 70.0796 150 71.2833V140C150 145.523 145.523 150 140 150H12C7.58173 150 4 146.418 4 142V70.3321Z",
    fill: "#DFE1F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 61.5761C0 60.9768 0.25939 60.4079 0.709052 60.0211L68.2397 1.92375C71.2359 -0.653974 75.6263 -0.639672 78.6063 1.95752L145.301 60.0845C145.745 60.4713 146 61.0363 146 61.6311V85H0V61.5761Z",
    fill: "#A4A8CD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 26C30 23.7909 31.7909 22 34 22H112C114.209 22 116 23.7909 116 26V96H30V26Z",
    fill: "#007FFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 62L68.4807 89.8401C71.3784 91.0182 74.6216 91.0182 77.5193 89.8401L146 62V138C146 142.418 142.418 146 138 146H8C3.58173 146 0 142.418 0 138V62Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58 57.2222L68.3188 67L90 43",
    stroke: "white",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 126,
    width: 35,
    height: 4,
    rx: 2,
    fill: "#007FFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 118,
    width: 19,
    height: 4,
    rx: 2,
    fill: "#007FFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSent);
export default __webpack_public_path__ + "static/media/email-sent.ec41d82d.svg";
export { ForwardRef as ReactComponent };